var EtdActions, Presentations, PresentationsView, ReactComponent, View, alt, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

alt = require('alt');

View = require('base/views/view');

ReactComponent = require('base/lib/traits/react_component');

Presentations = require('components/etd/presentations');

EtdActions = require('actions/etd_actions');

mediator = require('mediator');

module.exports = PresentationsView = (function(_super) {
  __extends(PresentationsView, _super);

  function PresentationsView() {
    return PresentationsView.__super__.constructor.apply(this, arguments);
  }

  PresentationsView.prototype.id = 'presentations-module';

  PresentationsView.prototype.container = '#page-container';

  PresentationsView.prototype.className = 'presentations-view';

  PresentationsView.prototype.autoRender = true;

  PresentationsView.prototype.initialize = function() {
    PresentationsView.__super__.initialize.apply(this, arguments);
    return this.enable(ReactComponent);
  };

  PresentationsView.prototype.afterRender = function() {
    PresentationsView.__super__.afterRender.apply(this, arguments);
    return this.renderSimpleComponent(Presentations, {});
  };

  PresentationsView.prototype.dispose = function() {
    if (this.disposed) {
      return;
    }
    this.unmountComponent();
    alt.recycle('AdolopmentDataStore', 'AdolopedEtdStore', 'EtdsStore', 'EtdStore', 'OrganizationsStore', 'QuestionsStore', 'QuestionsStatusesStore');
    return PresentationsView.__super__.dispose.apply(this, arguments);
  };

  return PresentationsView;

})(View);
